import { Component } from '@angular/core'
import { SectionTabsComponent } from '@employer/app/components/section-tabs/section-tabs.component'
import { ScreenHeaderComponent } from '@employer/app/components/screen-header/screen-header.component'
import { SettingsGroupHubComponent } from '@employer/app/components/settings-group-hub/settings-group-hub.component'

/**
 * Engage > Settings. The section tab row plus the Engage slice of the settings hub —
 * Pipeline Configuration, Automation Settings and the Question Library all still live
 * under /settings; this is the shortcut to them.
 */
@Component({
  selector: 'engage-settings',
  standalone: true,
  imports: [ScreenHeaderComponent, SectionTabsComponent, SettingsGroupHubComponent],
  template: `
<screen-header
      [kicker]="'Settings'"
      [icon]="'settings'"
      [title]="'Pipelines settings'"
      [subtitle]="'Company settings that apply to candidates and pipelines.'"
      [tone]="'engage'"
      [favoriteId]="'engage-settings'"
      [favoriteName]="'Pipelines Settings'"
    ></screen-header>
    <section-tabs [section]="'engage'"></section-tabs>
    <settings-group-hub [group]="'Pipelines'"></settings-group-hub>
  `,
})
export class EngageSettingsComponent {}
